













































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '../Store/FinanceiroStore'

@Component
export default class ModalItemsRecebimentoMonitor extends Vue {
  get modalItemsRecebimentoMonitor() { return this.getFinanceiroStore.modal.itemsRecebimentoMonitor }
  set modalItemsRecebimentoMonitor(value: boolean) { this.getFinanceiroStore.setModal({ name: 'itemsRecebimentoMonitor', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get itens() {
    return this.getFinanceiroStore.itensRecebimentoMonitor
  }

  formatLabel(label: string): string {
    return label.replace(/([A-Z])/g, ' $1').trim()
  }

  closeModalItemsRecebimentoMonitor() {
    this.getFinanceiroStore.setModal({ name: 'itemsRecebimentoMonitor', value: false })
  }
}
